import { createClient } from '@/shared/api';
import type {
  UpdateStudyInterprettingPhysicianMutation,
  UpdateStudyInterprettingPhysicianMutationVariables,
} from '@/shared/api';
import UPDATE_STUDY_INTERPETING_PHYSICIAN from '../mutations/updateStudyInterpretingPhysician';

/**
 * Assigns or changes the interpreting physician on a study. Runs UPDATE_STUDY_INTERPETING_PHYSICIAN and throws the returned message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns The updateStudyInterprettingPhysician payload.
 */
const handleUpdateStudyInterprettingPhysician = async (
  input: UpdateStudyInterprettingPhysicianMutationVariables['input'],
): Promise<UpdateStudyInterprettingPhysicianMutation['updateStudyInterprettingPhysician']> => {
  const client = createClient();
  const result = await client.mutate<
    UpdateStudyInterprettingPhysicianMutation,
    UpdateStudyInterprettingPhysicianMutationVariables
  >({
    mutation: UPDATE_STUDY_INTERPETING_PHYSICIAN,
    variables: {
      input,
    },
  });
  const { updateStudyInterprettingPhysician } = result?.data || {};
  if (!updateStudyInterprettingPhysician?.isSuccess) {
    throw new Error(updateStudyInterprettingPhysician?.message ?? undefined);
  }
  return updateStudyInterprettingPhysician;
};

export default handleUpdateStudyInterprettingPhysician;
